var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wf-search-result description", class: _vm.className },
    [
      _c("div", { staticClass: "wf-search-result-top" }, [
        _c(
          "a",
          {
            staticClass: "wf-search-result-image-wrapper",
            attrs: { href: _vm.link }
          },
          [
            _c("wf-load-image", {
              attrs: {
                wrapperClass: "wf-search-result-image d-flex",
                imageClass: "image full-image",
                src: _vm.imageUrl,
                alt: _vm.imageAltText || ""
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "wf-search-result-content flex-fill d-flex flex-column"
        },
        [
          _c(
            "a",
            { staticClass: "text-decoration-none", attrs: { href: _vm.link } },
            [
              _c("dl", [
                _c("div", { staticClass: "wf-search-result-content-page" }, [
                  _c("dt", {
                    staticClass: "mb-3",
                    domProps: { innerHTML: _vm._s(_vm.title) }
                  }),
                  _vm._v(" "),
                  _vm.content && _vm.content.length > 0
                    ? _c("dd", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.content) +
                            "\n          "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("dd", [
                    _vm._v("\n            " + _vm._s(_vm.date) + "\n          ")
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _vm.showViewButton
            ? [
                _c(
                  "a",
                  {
                    staticClass:
                      "btn btn-white border-primary w-100 mb-2 mt-auto",
                    attrs: { href: _vm.link }
                  },
                  [
                    _vm._v("\n        View\n        "),
                    _c("span", {
                      staticClass: "png-icon png-icon-icons-glyph--k-arrow-next"
                    })
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }